// extracted by mini-css-extract-plugin
module.exports = {"nav_link":"Navigation_nav_link__Ypg7x","nav_link__active":"Navigation_nav_link__active__18zqH"};